import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Cumpără 1, primești 1',
  [OFFER_TYPE.FREE_ITEM]: 'Articol gratuit',
  [OFFER_TYPE.AMOUNT_OFF]: 'Sumă redusă',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Procent redus',
};
